import axios from 'axios';
import { baseUrlNew, buildAuthHeaders } from './config';

export const fetchGraphData = (params) => {
  return axios.get(`${baseUrlNew}/emails/graph`, {
    params,
    headers: buildAuthHeaders()
  });
};
// export const fetchInboxList = function (params) {
//   const { period, startDate, endDate, domain } = params;
//   const queryString = `period=${period}&startDate=${startDate}&endDate=${endDate}&domain=${domain}`;
//   return axios.get(`${baseUrlNew}/emails/table?${queryString}`);
// };






// export const fetchPieGraphData = function (params) {
//   return axios.get(`${baseUrlNew}/emails/chart`, { params });
// };
export const fetchInboxList = async (params) => {
  const response = await axios.get(`${baseUrlNew}/emails/table`, {
    params,
    headers: buildAuthHeaders()
  });
  return response.data;
};

export const fetchDomainData = (domainId) => {
  return axios.get(`${baseUrlNew}/emails/autocomplete`, {
    params: { query: domainId },
    headers: buildAuthHeaders()
  });
};